import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Img from "../img/vp_logo1.jpg";
import Burger from "./Burger"; // Ensure this component exists
import "./Nav.css";

export default function Nav() {
  const [hamburgerIsOpen, setHamburgerIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleHamburger = () => {
    setHamburgerIsOpen((prev) => !prev);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  const menuclose =() =>{
    setHamburgerIsOpen(false)
    setIsDropdownOpen(false)
  }
  
  return (
    <nav id="nav">
      <div className="figure">
        <img src={Img} alt="Logo" />
      </div>

      {/* Hamburger Icon */}
      <div className="burger-list" onClick={toggleHamburger}>
        <Burger isOpen={hamburgerIsOpen} />
      </div>

      {/* Header Title */}
      <div className="header-title"><img src={Img} alt="Logo" height="50px" width="150px"/></div>

      {/* Navigation List */}
      <div className={`nav-list ${hamburgerIsOpen ? "nav-burger active" : ""}`}>
        <ul >
          <li>
            <NavLink exact to="/" activeClassName="active">
              Home
            </NavLink>
          </li>

          <li
            className="dropdown"
          >
            <div 
            
            onClick={toggleDropdown}
              >
                Product
            </div>
            {isDropdownOpen && (
              <ul className="dropdown-menu">
                <li>
                  <NavLink to="/s_machine" onClick={menuclose}>Strapping Machine</NavLink>
                </li>
                <li>
                  <NavLink to="/Sealingmachine" onClick={menuclose}>Continuous Band Sealing Machine
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/SealerMachine"onClick={menuclose}>Sealer Machine</NavLink>
                </li>
                <li>
                  <NavLink to="/vacuumpackingM"onClick={menuclose}>Vacuum Packing Machine</NavLink>
                </li>
                <li>
                  <NavLink to="/pastefM"onClick={menuclose}>Paste Filling Machine</NavLink>
                </li>
                <li>
                  <NavLink to="/ShrinkC"onClick={menuclose}>Shrink Chamber</NavLink>
                </li>
                <li>
                  <NavLink to="/ppm"onClick={menuclose}>Pouch Packing Machine</NavLink>
                </li>
                <li>
                  <NavLink to="/printer"onClick={menuclose}>PrinterS</NavLink>
                </li>
                <li>
                  <NavLink to="/wrappingM"onClick={menuclose}>Wrapping Machine</NavLink>
                </li>
                <li>
                  <NavLink to="/PetST"onClick={menuclose}>Pet Strapping Tool</NavLink>
                </li>
                {/* <li>
                  <NavLink to="/Product/Category3"onClick={menuclose}>Category 11</NavLink>
                </li> */}
              </ul>
            )}
          </li>

          <li>
            <NavLink exact to="/about" onClick={menuclose} activeClassName="active">
              About us
            </NavLink>
          </li>
          <li>
            <NavLink exact to="/contactus" onClick={menuclose} activeClassName="active">
            contact us
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}
